import { AgChartOptions } from "ag-charts-community";

import AnalyticsChart from "@/components/RequestsAnalytics/AnalyticsChart";

export type RequestVolumeTailConnectionState = "connecting" | "listening" | "delayed";

interface RequestVolumeTailChartProps {
  options: AgChartOptions;
  connectionState: RequestVolumeTailConnectionState;
}

const RequestVolumeTailChart = ({ options, connectionState }: RequestVolumeTailChartProps) => (
  <div
    className="relative h-full min-h-0 w-full overflow-visible"
    data-connection-state={connectionState}
  >
    <AnalyticsChart options={options} />
  </div>
);

export default RequestVolumeTailChart;
